import React, { useEffect, useState } from "react";
import styles from "./CookiesPolicy.module.css";
import { OPEN_COOKIES_POLICY } from "../utils/cookieEvents";

export default function CookiesPolicy({ onClose }) {
  const [isOpen, setIsOpen] = useState(false);
  const [isTableZoomed, setIsTableZoomed] = useState(false);
  const [sections, setSections] = useState([]);

  // 🔹 Otwieranie modala przez event
  useEffect(() => {
    const handleOpen = () => setIsOpen(true);
    window.addEventListener(OPEN_COOKIES_POLICY, handleOpen);
    return () => window.removeEventListener(OPEN_COOKIES_POLICY, handleOpen);
  }, []);

   // 🔹 Dynamiczna detekcja skryptów po załadowaniu strony
    useEffect(() => {
      const detectScripts = () => {
        const categories = [
          { key: "necessary", label: "Niezbędne (techniczne)" },
          { key: "analytics", label: "Analityczne (np. Google Analytics)" },
          { key: "marketing", label: "Marketingowe (np. Google Ads)" }
        ];
  
        const collectedSections = categories.map(cat => {
          const scripts = Array.from(
            document.querySelectorAll(`script[data-cookie="${cat.key}"]`)
          );
  
          // Filtrujemy niechciane źródła (np. reklamy zewnętrzne)
          const validScripts = scripts.filter(script => {
            const src = script.dataset.src || script.src || "";
            return (
              !src.includes("googlesyndication.com") &&
              !src.includes("doubleclick.net") &&
              !src.includes("googleadservices.com")
            );
          });
  
          if (validScripts.length === 0) return null;
  
          // Tworzymy listę wykrytych skryptów
          const items = validScripts.map(script => {
            const src = script.dataset.src || script.src || "";
            const name =
              script.dataset.name ||
              (src ? src.split("/").pop() : "Skrypt inline");
            const desc =
              script.dataset.desc || "Skrypt lub narzędzie używane przez stronę";
            return { name, desc };
          });
  
          return { ...cat, items };
        });
  
        setSections(collectedSections.filter(Boolean));
      };
  
      // 🔸 Wykonaj po załadowaniu DOM
      detectScripts();
  
      // (opcjonalnie) ponowna detekcja np. po dynamicznym załadowaniu tagów
      const observer = new MutationObserver(() => detectScripts());
      observer.observe(document.body, { childList: true, subtree: true });
  
      return () => observer.disconnect();
    }, []);
  

  if (!isOpen) return null;

  return (
    <>
      {/* 🔹 Overlay pod modalem */}
      <div
        className={styles.overlay}
        onClick={(e) => {
          if (e.target === e.currentTarget) onClose();
        }}
      >
        <div className={styles.modal} role="dialog" aria-modal="true">
          <h2 className={styles.title}>Polityka cookies</h2>

          <div className={styles.modalBody}>
          <section className={styles.section}>
            <p>
              Nasza strona internetowa używa plików cookies (ciasteczek), aby
              zapewnić prawidłowe działanie witryny, analizować ruch oraz
              dostosowywać treści i reklamy do Twoich zainteresowań. Poniżej
              znajdziesz szczegółowe informacje o rodzajach ciasteczek, które
              stosujemy i sposobie ich zarządzania.
            </p>
            <h2 className={styles.titlePoint}>1. Czym są pliki cookies?</h2>
            <p>
              Cookies to małe pliki tekstowe zapisywane w przeglądarce
              użytkownika, które umożliwiają rozpoznanie urządzenia i
              zapisanie pewnych ustawień oraz preferencji. Pliki cookies mogą
              być wykorzystywane m.in. do:
            </p>
            <ul>
              <li>zapamiętywania preferencji i ustawień użytkownika,</li>
              <li>analizowania ruchu na stronie,</li>
              <li>dostosowywania treści reklamowych.</li>
            </ul>
            <p>
              Cookies mogą być tymczasowe (sesyjne) — usuwane po zamknięciu
              przeglądarki, lub trwałe — pozostające na urządzeniu przez
              określony czas lub do momentu ich ręcznego usunięcia.
            </p>
          </section>
          <section className={styles.section}>
            <h2 className={styles.titlePoint}>2. W jakich celach wykorzytsujemy pliki cookies</h2>
            <h6>Niezbędne (techniczne)</h6>
            <p>
              Pliki wymagane do prawidłowego działania strony, np. logowanie,
              koszyk w sklepie, pamiętanie zgody na cookies. Te cookies są
              zawsze aktywne.
            </p>

            <h6>Analityczne</h6>
            <p>
              Pliki umożliwiające analizę zachowań użytkowników na stronie,
              np. Google Analytics. Dzięki nim możemy mierzyć liczbę
              odwiedzin, czas spędzony na stronie, najczęściej odwiedzane
              podstrony. Te cookies działają tylko po wyrażeniu zgody.
            </p>

            <h6>Marketingowe / reklamowe</h6>
            <p>
              Pliki używane do profilowania i personalizacji reklam, np.
              Google Ads, Facebook Pixel. Pozwalają dostosować reklamy do
              Twoich zainteresowań i mierzyć skuteczność kampanii. Te cookies
              działają wyłącznie po wyrażeniu zgody.
            </p>
          </section>

            {/* 🔹 === TABELA COOKIES === */}
            <section className={styles.section}>
              <h2 className={styles.titlePoint}>3. Rodzaje używanych plików cookies</h2>

              <table
                className={`${styles.cookiesTable} ${
                  isTableZoomed ? styles.zoomed : ""
                }`}
                id="cookiesTable"
                onClick={() => {
                  // jeśli powiększona → kliknięcie ją zamyka
                  if (isTableZoomed) {
                    setIsTableZoomed(false);
                  } else {
                    // jeśli normalna → powiększa
                    setIsTableZoomed(true);
                  }
                }}
              >
                <thead>
                  <tr>
                    <th>Typ cookie</th>
                    <th>Cel</th>
                    <th>Dostawca</th>
                    <th>Okres przechowywania</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td><strong>Niezbędne (techniczne)</strong></td>
                    <td>Zapewniają podstawowe funkcje serwisu.</td>
                    <td>Nazwa firmy</td>
                    <td>Do końca sesji</td>
                  </tr>

                  <tr>
                    <td><strong>Analityczne (_ga, _gid, _gat)</strong></td>
                    <td>Statystyki odwiedzin — Google Analytics</td>
                    <td>Google LLC</td>
                    <td>_ga: 2 lata • _gid: 24h • _gat: 1 min</td>
                  </tr>

                  <tr>
                    <td><strong>Marketingowe (IDE, test_cookie)</strong></td>
                    <td>Pomiar skuteczności reklam — Google Ads</td>
                    <td>Google Ireland Ltd.</td>
                    <td>IDE: 13 miesięcy • test_cookie: 15 min</td>
                  </tr>
                </tbody>
              </table>

              {/* 🔹 Overlay POD powiększoną tabelę */}
              {isTableZoomed && (
                <div
                  className={styles.tableOverlay}
                  onClick={() => setIsTableZoomed(false)}
                />
              )}
            </section>
            <section className={styles.section}>
            <ul>
              <li>
                <strong>_ga</strong> – Google Analytics, identyfikator użytkownika, czas przechowywania: 2 lata
              </li>
              <li>
                <strong>_gid</strong> – Google Analytics, identyfikator użytkownika, czas przechowywania: 24 godziny
              </li>
              <li>
                <strong>_fbp</strong> – Facebook Pixel, identyfikator użytkownika, czas przechowywania: 3 miesiące
              </li>
              <li>
                <strong>IDE</strong> – Google Ads, identyfikator reklamy, czas przechowywania: 1 rok
              </li>
            </ul>
          </section>
          <section className={styles.section}>
            <h2 className={styles.titlePoint}>4. Zarządzanie plikami cookies</h2>
            <p>
              Możesz w każdej chwili zmienić swoje ustawienia dotyczące
              cookies za pomocą naszego banera znajdującego się na naszej
              stronie internetowej lub w przeglądarce. W większości
              przeglądarek możesz:
            </p>
            <ul>
              <li>usunąć ciasteczka,</li>
              <li>zablokować automatyczne zapisywanie nowych ciasteczek,</li>
              <li>ustawić powiadomienia przy każdym zapisie cookies.</li>
            </ul>
            <p>
              Pamiętaj, że wyłączenie niektórych cookies może wpłynąć na
              funkcjonowanie strony i dostęp do niektórych funkcji.
            </p>
          </section>
          <section className={styles.section}>
            <h2 className={styles.titlePoint}>5. Pliki cookies podmiotów trzecich</h2>
            <p>
              Na naszej stronie mogą być używane pliki cookies pochodzące od
              podmiotów trzecich, takich jak Google (Analytics, Ads).
            </p>
            <p>
              Więcej informacji o zasadach przetwarzania danych przez te
              podmioty znajdziesz na stronach:
            </p>
            <ul className={styles.elementLinks}>
              <li>
                <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer" className={styles.modalLinks}>
                  Polityka prywatności Google
                </a>
              </li>
              <li>
                <a href="https://policies.google.com/technologies/cookies" target="_blank" rel="noopener noreferrer" className={styles.modalLinks}>
                  Zasady dotyczące plików cookie Google
                </a>
              </li>
            </ul>
          </section>
          <section className={styles.section}>
            <h2 className={styles.titlePoint}>6. Usuwanie i blokowanie plików cookies</h2>
            <p>
              Użytkownik w każdej chwili może zmienić ustawienia dotyczące
              plików cookies – zablokować ich automatyczne przyjmowanie lub
              usunąć zapisane pliki – za pomocą ustawień przeglądarki
              internetowej. Sposób zarządzania plikami cookies różni się w
              zależności od przeglądarki. Poniżej znajdują się przykładowe
              instrukcje dla najpopularniejszych przeglądarek:
            </p>
            <ul className={styles.elementLinks}>
              <li>
                Google Chrome:
                <a href="https://support.google.com/chrome/answer/95647?hl=pl" className={styles.modalLinks} target="_blank" rel="noreferrer">
                  <strong className={styles.item}>Instrukcja</strong>
                </a>
              </li>
              <li>
                Mozilla Firefox:
                <a href="https://support.mozilla.org/pl/kb/usuwanie-ciasteczek-i-danych-stron-firefox?redirectslug=usuwanie-ciasteczek&redirectlocale=pl" className={styles.modalLinks} target="_blank" rel="noreferrer">
                  <strong className={styles.item}>Instrukcja</strong>
                </a>
              </li>
              <li>
                Microsoft Edge:
                <a href="https://support.microsoft.com/pl-pl/microsoft-edge/usuwanie-plik%C3%B3w-cookie-w-przegl%C4%85darce-microsoft-edge-63947406-40ac-c3b8-57b9-2a946a29ae09" className={styles.modalLinks} target="_blank" rel="noreferrer">
                  <strong className={styles.item}>Instrukcja</strong>
                </a>
              </li>
              <li>
                Safari (macOS/iOS):
                <a href="https://support.apple.com/pl-pl/guide/safari/sfri11471/mac" className={styles.modalLinks} target="_blank" rel="noreferrer">
                  <strong className={styles.item}>Instrukcja</strong>
                </a>
              </li>
              <li>
                Opera:
                <a href="https://help.opera.com/pl/latest/web-preferences/#cookies" className={styles.modalLinks} target="_blank" rel="noreferrer">
                  <strong className={styles.item}>Instrukcja</strong>
                </a>
              </li>
            </ul>
            <p>
              Ograniczenie lub zablokowanie obsługi plików cookies może
              wpłynąć na działanie niektórych funkcjonalności strony
              internetowej, w tym uniemożliwić prawidłowe działanie niektórych
              usług.
            </p>
          </section>
          <section className={styles.section}>
            <h2 className={styles.titlePoint}>7. Kontakt</h2>
            <p>
              Jeśli masz pytania dotyczące polityki cookies lub przetwarzania
              danych osobowych napisz do nas za pomocą formaulrza lub
              bezpośrednio na naszego e-maila: e-mail firmy.
            </p>
          </section>
          <script type="text/plain" data-cookie="necessary" data-name="Niezbędne" />
          <script type="text/plain" data-cookie="analytics" data-src="https://www.googletagmanager.com/gtag/js?id=G-XXXXXXXXXX" data-name="Google Analytics" />
          <script type="text/plain" data-cookie="marketing" data-src="https://www.googletagmanager.com/gtag/js?id=AW-XXXXXXXXXXX" data-name="Google Ads" />

          {sections.length > 0 ? sections.map(section =>
                <section key={section.key} className={styles.section}>
                  <h2 className={styles.titlePoint}>
                    {section.label}
                  </h2>
                  <ul>
                    {section.items.map((item, i) =>
                      <li key={i}>
                        <strong>{item.name}</strong> – {item.desc}
                      </li>
                    )}
                  </ul>
                </section>
              ) : <p>
                Brak aktywnych narzędzi cookies wykrytych na stronie.
              </p>}
          </div>

          <div className={styles.actions}>
            <button
              onClick={() => setIsOpen(false)}
              className={styles.privacyBtn}
            >
              Zamknij
            </button>
          </div>
        </div>
      </div>
    </>
  );
}